module.exports = __webpack_public_path__ + "static/media/homeImage.50890cab.svg";